import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { getAuthMenu, getMenuPermission } from '@/api/User/user';
import { listToTree, permissionFilterTree } from '@/router';
import _ from 'lodash';
const compare = () => {
  return (a, b) => {
    const sortA = a.sort;
    const sortB = b.sort;
    return sortA - sortB;
  };
};
// 菜单排序
const sortRoutes = routes => {
  const sorted = routes.sort(compare());
  sorted.forEach(item => {
    item.children && item.children.length > 0 && sortRoutes(item.children);
  });
  return sorted;
};
export default {
  namespaced: true,
  state: () => ({
    menus: [],
    permissions: [],
    auhs: [],
    navMenus: [],
    collapsed: false // 左侧菜单是否已折叠
  }),
  mutations: {
    SET_PERS(state, permissions) {
      state.permissions = permissions;
    },
    SET_AUHS(state, auhs) {
      state.auhs = auhs;
    },
    SET_MENUS(state, menus) {
      state.menus = menus;
    },
    SET_NAV_MENUS(state, menus) {
      state.navMenus = menus;
    },
    SET_MENU_COLLAPSE(state, collapse) {
      state.collapsed = collapse;
    }
  },
  actions: {
    getMenus({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        const userInfo = JSON.parse(localStorage.getItem('cur_info'));
        const ispSupplierEntity = JSON.parse(localStorage.getItem('gys_cur_supplier_info'));
        let uri = '';
        if (!_.isEmpty(userInfo)) {
          uri = 'internal_menuSet';
        } else if (!_.isEmpty(ispSupplierEntity)) {
          uri = 'external_menuSet';
        }
        if (_.isEmpty(uri)) {
          return;
        }
        getAuthMenu(uri).then(res => {
          // 过滤
          res = permissionFilterTree(res, state.permissions);
          const menuRes = res.d.results;
          localStorage.setItem('menus', JSON.stringify(menuRes)); // 暂存到localStorage，避免刷新页面还没从接口取到菜单的时候，跳到404
          commit('SET_MENUS', menuRes);
          const menuList = listToTree(menuRes, 'Menuid', 'Parentid');
          commit('SET_NAV_MENUS', menuList);
          resolve(menuRes);
        }).catch(err => {
          reject(err);
        });
      });
    },
    getPers({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getMenuPermission().then(res => {
          const pers = res?.auth?.systemMsg[0]?.permissionMsg;
          const auts = res?.auth?.authorityObjectMsg;
          commit('SET_PERS', pers);
          commit('SET_AUHS', auts);
          resolve(pers);
        }).catch(err => {
          reject(err);
        });
      });
    }
  }
};